<script setup lang="ts">
import { computed } from 'vue';
const props = defineProps<{ icon?: string; size?: string | number; color?: string }>();
function resolveColor(value?:string){ if(!value) return undefined; if(value==='white') return '#fff'; if(value.startsWith('#') || value.startsWith('rgb') || value.startsWith('var(')) return value; return `rgb(var(--raya-theme-${value}, var(--raya-theme-on-surface)))`; }
const style = computed(() => ({
  fontSize: typeof props.size === 'number' || (props.size && /^\d+(\.\d+)?$/.test(props.size))
    ? `${props.size}px`
    : (props.size || undefined),
  color: resolveColor(props.color),
}));
</script>
<template>
  <i
    :class="['raya-icon','mdi', icon]"
    :style="style"
    aria-hidden="true"
  />
</template>
